const IDEAL_WORD_SPACE = 9;
const IDEAL_LETTER_WIDTH = 8;
const IDEAL_FONT_SIZE = 10;

let idealWordSpace = IDEAL_WORD_SPACE;
let idealLetterWidth = IDEAL_LETTER_WIDTH;
let idealFontSize = IDEAL_FONT_SIZE;

export const wrapText: (
  text: string,
  width: number,
  scaleFont: boolean,
  fontSize: number
) => {
  lines: Array<string>;
  fontSize: number;
} = (text, width, scaleFont, fontSize) => {
  if (fontSize) {
    updateFontSize(fontSize);
  }

  // We split each word and call the lines generator
  const result = linesGenerator(text.split(' '), width);

  if (!scaleFont) {
    return {
      lines: result.lines,
      fontSize: idealFontSize
    };
  }

  const scaledToWidth = (width * idealFontSize) / Math.max(...result.linesWidth);

  return {
    lines: result.lines,
    fontSize: scaledToWidth > idealFontSize ? idealFontSize : scaledToWidth
  };
};

const linesGenerator: (
  words: Array<string>,
  width: number
) => {
  lines: Array<string>;
  linesWidth: Array<number>;
} = (words, width) => {
  let lineWidth = 0;
  let lineCounter = 0;
  const lines = [];
  const linesWidth = [];

  words.forEach((word, i) => {
    const isLastWord = words.length - 1 === i;

    //  We add widths of each word
    lineWidth += getWordWidth(word) + (isLastWord ? 0 : idealWordSpace);
    //  If the width of the words collected fit
    if (lineWidth < width) {
      lines[lineCounter] = lines[lineCounter] || '';
      lines[lineCounter] += word.trim() + (isLastWord ? '' : ' ');
    } else {
      // if the first word of the first line does not fit in the first line, we don't want to go to the second line just yet
      // that is why we only put a word that is too long into the next line AFTER we have started putting content into the
      // current line
      if (lines[lineCounter]) {
        lineCounter++;
      }

      lines[lineCounter] = word.trim() + (isLastWord ? '' : ' ');
      lineWidth = getWordWidth(word) + idealWordSpace;
    }

    linesWidth.push(lineWidth);
  });

  return {
    lines,
    linesWidth
  };
};

const getWordWidth = (word: string): number => word.length * idealLetterWidth;

const updateFontSize = (size: number) => {
  idealFontSize = size;
  idealWordSpace = size * 0.9;
  idealLetterWidth = size * 0.8;
};
